<div class="flex flex-col justify-center items-center">
  <img
    class="errorPage__img"
    src="../assets/img/{{ error.image }}"
    alt="Error image"
  />
  <div>
    <h3>{{ error.message }}</h3>
  </div>
</div>
